// src/redux/actions.js
export const resetCache = () => ({
    type: 'RESET_CACHE',
});

export const setChannelCreated = (value) => ({
    type: 'SET_CHANNEL_CREATED',
    payload: value,
});

export const setChannelDeleted = (value) => ({
    type: 'SET_CHANNEL_DELETED',
    payload: value,
});

export const setChannelUpdated = (value) => ({
    type: 'SET_CHANNEL_UPDATED',
    payload: value,
});

export const setCategoryCreated = (value) => ({
    type: 'SET_CATEGORY_CREATED',
    payload: value,
});
